export enum OTPDeliveryMethod {
  SMS = "sms",
  WHATSAPP = "whatsapp"
}

export enum OTPMatchConditionType {
  PHONE_PREFIX = "phone_prefix",
  MATCH_ALL = "match_all"
}

export enum OTPOperator {
  IN_LIST = "in_list",
  NOT_IN_LIST = "not_in_list",
  EQUALS = "equals",
  NOT_EQUALS = "not_equals"
}

export interface OTPMatchCondition {
  type: OTPMatchConditionType;
  operator: OTPOperator;
  values?: string[];
}

export interface OTPDeliveryResult {
  primary_method: OTPDeliveryMethod;
  resend_options: OTPDeliveryMethod[];
}

export interface OTPDeliveryRule {
  rule_id: string;
  description: string;
  match_condition: OTPMatchCondition;
  result: OTPDeliveryResult;
  enabled: boolean;
}

export interface OTPGlobalSettings {
  force_method: OTPDeliveryMethod | null;
  disable_otp: boolean;
}

export interface OTPConfig {
  global_settings: OTPGlobalSettings;
  delivery_rules: OTPDeliveryRule[];
}